import React, { Component } from "react";
import { Card } from "material-ui/Card";
import { Flex, Box } from "rebass";
import { connect } from "react-redux";
import compose from "recompose/compose";
import { showNotification as showNotificationAction } from "admin-on-rest";
// import { translate } from "admin-on-rest";
import Moment from "moment";
import { extendMoment } from "moment-range";

import DatePicker from "material-ui/DatePicker";
import RaisedButton from "material-ui/RaisedButton";
import { ViewTitle } from "../../components";
import { HeaderTitleChart } from "../styled";
import { RestApiChartCampaigns } from "../../restClient";
import ViewChart from "./ViewChart";
import OrderChart from "./OrderChart";

const moment = extendMoment(Moment);

class CampaignChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      campaignId: props.match.params.id,
      fromDate: moment()
        .subtract(6, "d")
        .format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
      dataViews: [],
      dataOrders: [],
      defaultViews: [],
      defaultOrders: []
    };
  }

  componentWillMount() {
    const { campaignId, fromDate, toDate } = this.state;
    this.setDefaultRangeDate(fromDate, toDate);
    this.getChartCampaignView(campaignId, fromDate, toDate);
    this.getChartCampaignOrders(campaignId, fromDate, toDate);
  }

  setDefaultRangeDate = (fromDate, toDate) => {
    const range = moment.range(fromDate, toDate);
    const acc = Array.from(
      range.by("days", { excludeStart: false, excludeEnd: false })
    );
    const resultView = acc.map(m => {
      return {
        date: m.format("YYYY-MM-DD"),
        product_id: 0,
        product_name: "",
        user_id: 0,
        first_name: "",
        last_name: "",
        views: 0
      };
    });
    const resultOrders = acc.map(m => {
      return {
        date: m.format("YYYY-MM-DD"),
        product_id: 0,
        product_name: "",
        user_id: 0,
        first_name: "",
        last_name: "",
        discounted_price: 0,
        qty: 0
      };
    });

    this.setState({
      defaultViews: resultView,
      defaultOrders: resultOrders
    });
  };

  handleChangeFromDate = (event, date) => {
    this.setState({
      fromDate: date
    });
  };

  handleChangeToDate = (event, date) => {
    this.setState({
      toDate: date
    });
  };

  getChartCampaignView = (paramsId, startDate, endDate) => {
    RestApiChartCampaigns(paramsId, startDate, endDate, "view")
      .then(response => response.json())
      .then(items => {
        if (items && !items.message) {
          // console.log(items);
          this.setState({
            dataViews: items
          });
        } else {
          this.props.showNotification(items.message, "warning");
        }
      })
      .catch(e => {
        // console.log(e);
      });
  };
  getChartCampaignOrders = (paramsId, startDate, endDate) => {
    RestApiChartCampaigns(paramsId, startDate, endDate, "order")
      .then(response => response.json())
      .then(items => {
        // console.log(items);
        if (items && !items.message) {
          this.setState({
            dataOrders: items
          });
        } else {
          this.props.showNotification(items.message, "warning");
        }
      })
      .catch(e => {
        // console.log(e);
      });
  };
  onSubmit = () => {
    const { campaignId, fromDate, toDate } = this.state;
    const startDate = moment(fromDate).format("YYYY-MM-DD");
    const endDate = moment(toDate).format("YYYY-MM-DD");
    this.setDefaultRangeDate(fromDate, toDate);
    this.getChartCampaignView(campaignId, startDate, endDate);
    this.getChartCampaignOrders(campaignId, startDate, endDate);
  };
  render() {
    const { dataOrders, dataViews, defaultOrders, defaultViews } = this.state;
    return (
      <Card containerStyle={{ minHeight: 318 }}>
        <ViewTitle title={<HeaderTitleChart {...this.props} />} />
        <Flex
          w={[1]}
          p={[1]}
          px={[2]}
          wrap
          direction={["row"]}
          align={["center"]}
        >
          <Box p={[1]}>
            <DatePicker
              onChange={this.handleChangeFromDate}
              autoOk={true}
              floatingLabelText="From Date"
              value={new Date(this.state.fromDate)}
            />
          </Box>
          <Box p={[1]}>
            <DatePicker
              onChange={this.handleChangeToDate}
              autoOk={true}
              floatingLabelText="To Date"
              value={new Date(this.state.toDate)}
              minDate={new Date(this.state.fromDate)}
            />
          </Box>
          <Box p={[1]}>
            <RaisedButton
              label="Search"
              primary={true}
              onClick={this.onSubmit}
            />
          </Box>
        </Flex>
        <Box w={[1]}>
          <ViewChart data={dataViews} defaultData={defaultViews} />
        </Box>
        <Box w={[1]}>
          <OrderChart data={dataOrders} defaultData={defaultOrders} />
        </Box>
      </Card>
    );
  }
}

const enhance = compose(
  connect(
    (state, props) => {
      return {};
    },
    { showNotification: showNotificationAction }
  )
);

export default enhance(CampaignChart);



// WEBPACK FOOTER //
// ./src/campaigns/chart/CampaignChart.js